import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { api, brl, bulkPrice, errMsg } from "@/lib/api";

export const ApplyCostDialog = ({ target, onClose, onApplied }) => {
  const [usage, setUsage] = useState(null);
  const [busy, setBusy] = useState(false);
  const ing = target?.ingredient;
  useEffect(() => { setUsage(null); if (ing) api.get(`/ingredients/${ing.id}/usage`).then((r) => setUsage(r.data)).catch(() => setUsage({ recipes: [], combos: [] })); }, [ing]);
  if (!target) return null;
  const before = bulkPrice(ing);
  const unit = target.costUnit || before.unit;
  const apply = async () => {
    setBusy(true);
    try {
      await api.post(`/ingredients/${ing.id}/apply-cost`, { cost: Math.round(target.cost * 100) / 100, cost_unit: unit });
      toast.success(`Custo de ${ing.name} atualizado para ${brl(target.cost)}/${unit}`);
      window.dispatchEvent(new Event("pb:stock-changed"));
      onApplied?.(); onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const list = (arr) => arr.length ? ` (${arr.slice(0, 4).join(", ")}${arr.length > 4 ? ` e mais ${arr.length - 4}` : ""})` : "";
  return (
    <AlertDialog open onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="apply-cost-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Aplicar custo ajustado no cadastro?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm text-muted-foreground">
              <p data-testid="apply-cost-text">Isso vai atualizar o custo cadastrado de <span className="font-semibold text-foreground">{ing.name}</span> de <span className="num font-semibold text-foreground" data-testid="apply-cost-before">{brl(before.cost)}/{before.unit}</span> para <span className="num font-semibold text-primary" data-testid="apply-cost-after">{brl(target.cost)}/{unit}</span>.</p>
              <p data-testid="apply-cost-usage">{usage == null ? "Verificando fichas e combos que usam esse insumo…" : usage.recipes.length ? `Essa mudança afeta o custo de ${usage.recipes.length} ${usage.recipes.length === 1 ? "ficha técnica" : "fichas técnicas"}${list(usage.recipes)}${usage.combos.length ? ` e ${usage.combos.length} ${usage.combos.length === 1 ? "combo" : "combos"}${list(usage.combos)}` : ""}. Preços sugeridos e margens serão recalculados na hora.` : "Nenhuma ficha técnica usa esse insumo hoje — só o cadastro será atualizado."} Confirma?</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="apply-cost-cancel">Cancelar</AlertDialogCancel>
          <Button onClick={apply} disabled={busy || usage == null} data-testid="apply-cost-confirm">{busy ? "Aplicando..." : "Aplicar"}</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
